var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 10C3 9.44772 3.44772 9 4 9H36C36.5523 9 37 9.44772 37 10V30C37 30.5523 36.5523 31 36 31H4C3.44772 31 3 30.5523 3 30V10ZM5 11V16.7311C5.93579 16.515 6.87427 16.3184 7.81561 16.1418C11.8223 15.3901 15.8793 15 20 15C24.1207 15 28.1777 15.3901 32.1844 16.1418C33.1257 16.3184 34.0642 16.515 35 16.7311V11H5ZM35 18.7853C34.3345 18.6269 33.6679 18.4787 33 18.3409V29H35V18.7853ZM31 29V17.9598C27.3771 17.327 23.7144 17 20 17C16.2856 17 12.6229 17.327 9 17.9598V29H31ZM7 29V18.3409C6.33212 18.4787 5.66548 18.6269 5 18.7853V29H7ZM7 13C7 12.4477 7.44772 12 8 12H32C32.5523 12 33 12.4477 33 13C33 13.5523 32.5523 14 32 14H8C7.44772 14 7 13.5523 7 13ZM12 21C12 20.4477 12.4477 20 13 20H27C27.5523 20 28 20.4477 28 21C28 21.5523 27.5523 22 27 22H13C12.4477 22 12 21.5523 12 21ZM11 25C11 24.4477 11.4477 24 12 24H15C15.5523 24 16 24.4477 16 25C16 25.5523 15.5523 26 15 26H12C11.4477 26 11 25.5523 11 25ZM17 25C17 24.4477 17.4477 24 18 24H22C22.5523 24 23 24.4477 23 25C23 25.5523 22.5523 26 22 26H18C17.4477 26 17 25.5523 17 25ZM24 25C24 24.4477 24.4477 24 25 24H28C28.5523 24 29 24.4477 29 25C29 25.5523 28.5523 26 28 26H25C24.4477 26 24 25.5523 24 25Z",
    fill: "#006FCF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialSecurity);
export default __webpack_public_path__ + "static/media/social-security.a4f01378c492b0ee4cce8c6e882c799b.svg";
export { ForwardRef as ReactComponent };